import { ActivateListenerPayload, enums } from '@optimizely/optimizely-sdk'

import {
  createCheggInstance,
  FullStackTrackable,
  TrackingAdapter,
} from '@chegg/optimizely-sdk'
import { getCookieDomain } from '@src/state/site/selectors'
import site from '@src/state/site/site'
import siteConfig from '@src/state/site/siteConfig'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import { addQueryParams } from '@src/utils/queryParams'
import * as Cookies from 'js-cookie'

// Configure dataLayer allocation event
// move to middleware
export function onActivate(activateObject: ActivateListenerPayload) {
  const eventCategory = 'Optimizely'
  const eventAction = `Experiment - ${activateObject.experiment.key}`
  const eventLabel = `Variation - ${activateObject.variation.key}`

  // @ts-ignore
  window.dataLayer.push({
    eventCategory,
    eventAction,
    eventLabel,
    event: 'event',
  })
}

const queryStringOnPageLoad = window?.location?.search
const OPT_IS_SEM_COOKIE = 'opt-is-sem'
const OPT_IS_SEM_COOKIE_VALUE = 'true'
const SEM_PARAM_KEY = 'c_id'
const SEM_PARAM_VALUE = 'sem'

// EB landing pages set cookie to let us know users came from SEM.
// Once we integrate Optly Fullstack and Optly Web,
// or we add Optly Fullstack to landing pages, we won't need this.
const addSemQueryParamFromCookie = (queryString: string): string => {
  return Cookies.get(OPT_IS_SEM_COOKIE) === OPT_IS_SEM_COOKIE_VALUE
    ? addQueryParams(queryString, { [SEM_PARAM_KEY]: SEM_PARAM_VALUE })
    : queryString
}

let trackingAdapterClient: TrackingAdapter

export const trackOptimizelyEvent = (event: FullStackTrackable) => {
  if (!trackingAdapterClient || !event.eventKey) {
    return
  }
  trackingAdapterClient(event)
}

export let resolveRioPromise: () => void
const rioInitPromise: Promise<void> = new Promise(resolve => {
  resolveRioPromise = resolve
})

const initialize = () => {
  const { optimizelySdkKey, optimizelyProjectId } = siteConfig(site, LOCAL_OR_PLAYGROUND)

  // check that we are either not in a production build, or that they have agreed to be tracked
  // @ts-ignore
  const gdpr = LOCAL_OR_PLAYGROUND || window.__sbmNoGdpr === true

  if (!(optimizelySdkKey && gdpr)) {
    return null
  }

  const { optimizely, trackingAdapter } = createCheggInstance({
    queryStringOnPageLoad: addSemQueryParamFromCookie(queryStringOnPageLoad),
    cookieDomain: getCookieDomain(site),
    sdkKey: optimizelySdkKey,
    rioConfig: { project_id: optimizelyProjectId, rioInitPromise },
    logLevel: LOCAL_OR_PLAYGROUND ? enums.LOG_LEVEL.INFO : enums.LOG_LEVEL.ERROR,
  })

  optimizely.notificationCenter.addNotificationListener(
    enums.NOTIFICATION_TYPES.ACTIVATE,
    onActivate
  )
  trackingAdapterClient = trackingAdapter

  return optimizely
}

export default initialize()



// WEBPACK FOOTER //
// ./src/state/optimizely/optimizely.ts